import "../asset/css/main.css";
import Container from '@mui/material/Container'
import { CssBaseline } from "@mui/material";
import { Outlet } from "react-router-dom";
import Back from "../layout/Back";
import Footer from "../layout/Footer";
import { useEffect } from "react";
// import { useState } from "react";
import axios from 'axios';

function Main() {
  // Chromeless when loaded in-app: ?embed present, inside an iframe,
  // or the legacy id= case. Otherwise show header + footer.
  const _p = new URLSearchParams(window.location.search);
  let _inIframe = false;
  try { _inIframe = window.self !== window.top; } catch (e) { _inIframe = true; }
  const embedMode = (_p.get('embed') !== null) || (_p.get('embeded') !== null) || _inIframe || (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || (window.navigator && window.navigator.standalone === true) || (window.location.href.split('id=')[1] ? true : false);
	/*  const [searchParams] = useSearchParams();
  const wpUserId = searchParams.get('wp_user');

  useEffect(() => {
    if (wpUserId) {
      authenticateWordPressUser(wpUserId);
    }
  }, [wpUserId]);

  const authenticateWordPressUser = async (userId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/user/wp-login`,
        { wp_user_id: userId }
      );

      if (response.data.status) {
        // Store authentication data
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user_id', response.data.user_id);
        localStorage.setItem('username', response.data.username);
        localStorage.setItem('email', response.data.email);
        localStorage.setItem('wp_user_id', response.data.wp_user_id);
        
        // Refresh the page to apply authentication
        window.location.reload();
      } else {
        console.error('WordPress authentication failed:', response.data.errorMessage);
      }
    } catch (error) {
      console.error('Error authenticating WordPress user:', error);
    }
  }; */
  
  return (
    <>
      <CssBaseline />
      {embedMode ? ("") : (<Back />)}
      <Container className="main-container" maxWidth={embedMode ? ("auto") : ("lg")} sx={{ paddingTop: embedMode ? "0px" : "110px" }}>
        <Outlet />
      </Container>
      {embedMode ? ("") : (<Footer />)}

    </>

  )
}

export default Main